export { default as FramedIcon, type FramedIconProps } from './FramedIcon';
